export default __webpack_public_path__ + "static/media/Prashant Resume.5c748610.pdf";